import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const RequestPushMsg = async (token, data) => {
    const {
        config,
        auth,
    } = firebase;

    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/send_notification`;

    let idToken = '';
    try {
        if (auth && auth.currentUser) idToken = await auth.currentUser.getIdToken();
    } catch (_) {}

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(idToken ? { 'Authorization': `Bearer ${idToken}` } : {}),
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
    .then(() => {})
    .catch((error) => {
        console.log(error)
    });
}